import { render, staticRenderFns } from "./ModuleMonitorV2.vue?vue&type=template&id=04f6ef28&scoped=true&"
import script from "./ModuleMonitorV2.vue?vue&type=script&lang=js&"
export * from "./ModuleMonitorV2.vue?vue&type=script&lang=js&"
import style0 from "./ModuleMonitorV2.vue?vue&type=style&index=0&id=04f6ef28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6ef28",
  null
  
)

export default component.exports